import { useLingui } from "@lingui/react";

import { SELLER } from "./seller";

// Имя продавца на языке интерфейса.
export const useSellerName = (): string => {
  const { i18n } = useLingui();
  return i18n.locale.startsWith("ru") ? SELLER.name.ru : SELLER.name.en;
};
